export default "__VITE_ASSET__1e72dfde__"